import { CalendarRange, House, PackageOpen, ShoppingBasket, UserRound, UtensilsCrossed } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import { cn } from "@/lib/utils";


const navItems = [
  { to: "/", label: "Home", icon: House, testId: "nav-dashboard-link" },
  { to: "/planner", label: "Week", icon: CalendarRange, testId: "nav-planner-link" },
  { to: "/recipes", label: "Recepten", icon: UtensilsCrossed, testId: "nav-recipes-link" },
  { to: "/grocery", label: "Lijst", icon: ShoppingBasket, testId: "nav-grocery-link" },
  { to: "/pantry", label: "Pantry", icon: PackageOpen, testId: "nav-pantry-link" },
  { to: "/profile", label: "Profiel", icon: UserRound, testId: "nav-profile-link" },
];


export const MobileShell = ({ title, eyebrow, action, children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div
      className="bg-[radial-gradient(circle_at_top_left,_rgba(255,209,102,0.34),_transparent_26%),radial-gradient(circle_at_bottom_right,_rgba(111,168,132,0.22),_transparent_30%),linear-gradient(180deg,_#fbf7ef_0%,_#f4efe3_45%,_#edf3ea_100%)] px-3 pb-20 pt-3 sm:px-6 sm:pb-3"
      style={{
        minHeight: "100dvh",
        paddingTop: "max(0.75rem, env(safe-area-inset-top))",
      }}
    >
      <div
        className="mx-auto flex w-full max-w-md flex-col overflow-hidden rounded-[34px] border border-white/70 bg-white/70 soft-shadow page-enter"
        style={{ minHeight: "calc(100dvh - 6.25rem)" }}
      >
        <header className="glass-panel border-b border-stone-200/70 px-5 pb-4 pt-6" data-testid="mobile-shell-header">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.32em] text-emerald-700" data-testid="mobile-shell-eyebrow">
                {eyebrow}
              </p>
              <h1 className="mt-3 text-4xl font-semibold leading-none text-stone-900" data-testid="mobile-shell-title">
                {title}
              </h1>
            </div>
            {action ? <div data-testid="mobile-shell-action">{action}</div> : null}
          </div>
        </header>

        <main className="flex-1 px-4 pb-36 pt-4" data-testid="mobile-shell-main">
          {children}
        </main>
      </div>

      <nav className="glass-panel pointer-events-auto fixed left-1/2 z-[120] flex w-[calc(100%-5rem)] max-w-[22rem] -translate-x-1/2 items-center justify-between rounded-[26px] border border-white/80 px-2 py-2 shadow-[0_18px_45px_rgba(57,72,43,0.18)]" style={{ bottom: "max(3.75rem, env(safe-area-inset-bottom))" }} data-testid="bottom-navigation">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.to;

          return (
            <button
              key={item.to}
              type="button"
              onClick={() => navigate(item.to)}
              className={cn(
                "flex min-w-[48px] touch-manipulation flex-col items-center gap-1 rounded-[18px] px-2 py-2 text-[10px] font-medium transition-all duration-200",
                isActive ? "bg-emerald-700 text-white" : "text-stone-500 hover:bg-stone-100/80 hover:text-stone-900",
              )}
              data-testid={item.testId}
              aria-current={isActive ? "page" : undefined}
            >
              <Icon className="h-4 w-4" />
              <span data-testid={`${item.testId}-label`}>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};